import { Types } from "bitecs";

export const Vector3 = { x: Types.f32, y: Types.f32, z: Types.f32 };
